import useBiografiaStore from "./biografia";
const useConfiguracionStore = defineStore("configuracion", () => {
  // state
  const configuracion = ref({
    id: null,
    papel_id: null,
    papel: null,
    paginas: 12,
    titulo: null,
    sub_titulo: null,
    tipo_biografia_id: null,
    tipo_biografia: null,
    estatus: 2, // sin completar por default
    paginas_cap: 10, // mínimo 10 paginas
    cliente_id: null,
    cliente: null,
    invitaciones: [],
    tono: null, // [1 => Serio y Sobrio, 2 => Cercano y coloquial, 3 => Inspirador y Emotivo, 4 => Profesional y técnico, 5 => Con humor o Anécdotico]
    narracion: null, // [1 => 1ra persona, 2 => 3ra persona]
    extension_libro: null, // [1 => Breve (hasta 40 páginas), 2 => Mediana (40-100 páginas), 3 => Completa (100-200 páginas), 4 => Extensa (más de 200 páginas)]
    participacion_tercero: 3, // [1 => Si, 2 => No, 3 => Aun no lo se]
    tipo_nombre: "",
    es_beneficio: false,
    paginas_beneficio: 150,
  });

  const configuraciones = ref([]);

  const optionsTono = ref([
    { value: 1, text: "Serio y Sobrio" },
    { value: 2, text: "Cercano y coloquial" },
    { value: 3, text: "Inspirador y Emotivo" },
    { value: 4, text: "Profesional y técnico" },
    { value: 5, text: "Con humor o Anécdotico" },
  ]);

  //[1 => 1ra persona, 2 => 3ra persona]
  const optionsNarracion = ref([
    { value: 1, text: "Primera persona (Recuerdo aquel dia cuando...)" },
    { value: 2, text: "Tercera persona (A ella le gustaban las...)" },
  ]);

  // [1 => Breve (hasta 40 páginas), 2 => Mediana (40-100 páginas), 3 => Completa (100-200 páginas), 4 => Extensa (más de 200 páginas)]
  const optionsExtension = ref([
    { value: 1, text: "Breve (hasta 40 páginas)" },
    { value: 2, text: "Mediana (40-100 páginas)" },
    { value: 3, text: "Completa (100-200 páginas)" },
    { value: 4, text: "Extensa (más de 200 páginas)" },
  ]);

  // [1 => Si, 2 => No, 3 => Aun no lo se]
  const optionsParticacion = ref([
    { value: 1, text: "Si" },
    { value: 2, text: "No" },
    { value: 3, text: "Aun no lo se" },
  ]);

  // getters

  const draft = computed(() => clone(configuracion.value));

  // methods

  const getTipo = async (type) => {
    return configuracion.value.tipo_nombre || "S/D";
  };

  const getTono = (tono) => {
    return optionsTono.value.find((item) => item.value === tono)?.text || null;
  };

  const getNarracion = (narracion) => {
    return (
      optionsNarracion.value.find((item) => item.value === narracion)?.text ||
      null
    );
  };

  const getNombreAutor = computed(() => {
    return (biografiable) => {
      return biografiable
        ? `${biografiable.nombre_autor} ${biografiable.apellido_autor}`
        : "S/D";
    };
  });

  const getExtensionLibro = (extension) => {
    return (
      optionsExtension.value.find((item) => item.value === extension)?.text ||
      null
    );
  };

  const setConfiguracion = (payload) => {
    configuracion.value = payload;
  };

  const guardarConfiguracionEnLocalStorage = (config) => {
    localStorage.setItem("biografia_pendiente", JSON.stringify(config));
  };
  const cargarConfiguracionDesdeLocalStorage = () => {
    const config = localStorage.getItem("biografia_pendiente");
    if (config) {
      configuracion.value = JSON.parse(config);
      localStorage.removeItem("biografia_pendiente");
    }
  };

  const clear = () => {
    configuracion.value = {
      id: null,
      papel_id: null,
      papel: null,
      paginas: 10,
      titulo: null,
      sub_titulo: null,
      tipo_biografia_id: null,
      tipo_biografia: null,
      estatus: 2, // sin completar por default
      paginas_cap: 10, // min 10 paginas
      cliente_id: null,
      cliente: null,
      invitaciones: [],
      tono: null, // [1 => Serio y Sobrio, 2 => Cercano y coloquial, 3 => Inspirador y Emotivo, 4 => Profesional y técnico, 5 => Con humor o Anécdotico]
      narracion: null, // [1 => 1ra persona, 2 => 3ra persona]
      extension_libro: null, // [1 => Breve (hasta 40 páginas), 2 => Mediana (40-100 páginas), 3 => Completa (100-200 páginas), 4 => Extensa (más de 200 páginas)]
      participacion_tercero: 3, // [1 => Si, 2 => No, 3 => Aun no lo se]
      tipo_nombre: "",
      es_beneficio: false,
      paginas_beneficio: 150,
    };
  };

  const setConfiguraciones = (payload) => (configuraciones.value = payload);

  // actions
  const fetch = (confi_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/configuracions/${confi_id}/fetch-data`)
        .then(({ data }) => {
          setConfiguracion(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/configuracions/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/configuracions/${datos.id}`, datos)
          .then(({ data }) => {
            if (data.result) configuracion.value = data.configuracion;
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/configuracions`, datos)
          .then(({ data }) => {
            if (data.result) {
              configuracion.value = data;

              if (configuracion.value.biografia) {
                const biografiaStore = useBiografiaStore();

                biografiaStore.setBiografia(configuracion.value.biografia);
              }
            }

            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (configuracion_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/configuracions/${configuracion_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetch_data_biografias_beneficiables = async (params) => {
    try {
      const { data } = await axios.post(
        `/api/configuracions/fetch-data-biografias-beneficiables`,
        params
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const guardar_configuracion_beneficiable = async (datos) => {
    try {
      if (datos.id) {
        const { data } = await axios.put(
          `api/configuracions/${datos.id}`,
          datos
        );
        return data;
      } else {
        const { data } = await axios.post(
          `api/configuracions/guardar-configuracion-beneficiable`,
          datos
        );
        return data;
      }
    } catch (error) {
      throw error;
    }
  };

  const fetchListSelect = async (params) => {
    try {
      const { data } = await axios.post(
        `/api/configuracions/fetch-list-select`,
        params
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    configuracion,
    configuraciones,
    draft,
    optionsTono,
    optionsNarracion,
    optionsExtension,
    optionsParticacion,
    getNombreAutor,
    getTono,
    getNarracion,
    getExtensionLibro,
    getTipo,

    setConfiguracion,
    setConfiguraciones,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    guardarConfiguracionEnLocalStorage,
    cargarConfiguracionDesdeLocalStorage,
    fetch_data_biografias_beneficiables,
    guardar_configuracion_beneficiable,
    fetchListSelect,
  };
});

export default useConfiguracionStore;
